import { useEffect } from 'react';
import { useState } from 'react';
import { ChannelMemberAPIResponse, ChannelMemberResponse } from 'stream-chat';
import { useChannelStateContext, useTranslationContext } from 'stream-chat-react';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import './MembersDropdown.css';

export default function MembersDropdown() {
  const [open, setOpen] = useState(false);
  const { channel, watcher_count } = useChannelStateContext();
  const [members, setMembers] = useState<ChannelMemberResponse[] | undefined>();
  const { t } = useTranslationContext('ChannelHeader');

  const formLetter = channel.type == 'FORM_LETTER';
  useEffect(() => {
    if (formLetter) {
      return;
    }
    if (!open) {
      setMembers(undefined);
    }
    async function getAllMembers() {
      let allMembers: ChannelMemberResponse[] = [];
      let offset = 0;
      const limit = 100;
      let response: ChannelMemberAPIResponse;

      do {
        response = await channel.queryMembers({}, {}, { limit: limit, offset: offset });
        allMembers = [...allMembers, ...response.members];
        offset += limit;
      } while (response.members.length > 0);
      setMembers(allMembers);
    }
    void getAllMembers();
  }, [open, channel]);

  const { member_count } = channel.data || {};
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <p
        className="str-chat__channel-header-info"
        onClick={() => {
          setOpen(!open);
        }}
      >
        {!!member_count && member_count > 0 && (
          <span>
            {t('{{ memberCount }} members', {
              memberCount: member_count,
            })}
            ,{' '}
          </span>
        )}
        {t('{{ watcherCount }} online', { watcherCount: watcher_count })}
        {!formLetter &&
          (open ? <KeyboardArrowUp className="dropdown-arrow" /> : <KeyboardArrowDown className="dropdown-arrow" />)}
      </p>
      {!formLetter && open && members && (
        <div className="memberlist-conatiner">
          <ul className="memberlist-ul">
            {members.map((m) => (
              <li key={m.user?.id} style={{ padding: '4px 0' }}>
                <span className={m.user?.online ? 'online-indicator' : 'offline-indicator'}></span>
                <span className={m.user?.online ? '' : 'offline-name'}>{m.user?.name ?? m.user?.id} </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
